import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { SHARED_ENVIRONMENT } from '@k12/environment';
import { EnrollmentApplicationStatus, ProgramTypeKey } from '@k12/models';
import { Observable } from 'rxjs';

/**
 * One probe answering "where does this user belong for this program type right now". Deliberately a
 * single round trip: the server composes the caller's own application state with the enrollment
 * period's open/closed state, so the client never does date math or a second period lookup.
 */
@Injectable({ providedIn: 'root' })
export class EnrollmentAccessService {
  private readonly http = inject(HttpClient);
  private readonly sharedEnvironment = inject(SHARED_ENVIRONMENT);
  private readonly apiUrl = this.sharedEnvironment.adminApiUrl;

  public getStatus(programType: ProgramTypeKey, academicYearId?: number): Observable<EnrollmentApplicationStatus> {
    let params = new HttpParams().set('programType', programType);
    if (academicYearId) {
      params = params.set('academicYearId', academicYearId);
    }

    return this.http.get<EnrollmentApplicationStatus>(
      `${this.apiUrl}/enrollment/application/status`, { params });
  }
}
